
var React = require('react'),
  ClassNames = require('classnames');

var Glyphicon = require('react-bootstrap/lib/Glyphicon');

var Player = require('./app/components/player.jsx'),
  Button = require('./app/components/button.jsx'),
  TrackMenuButton = require('./app/components/track/menu.jsx'),
  PlaylistMenuButton = require('./app/components/playlist/menu.jsx'),
  MobilePlaylistMenuButton = require('./app/components/playlist/mobile-menu.jsx'),
  TrackNumber = require('./app/components/track/number.jsx'),
  PlayPauseButton = require('./app/components/play.jsx'),
  ProgressBar = require('./app/components/progress/sliding-bar.jsx'),
  ProgressTime = require('./app/components/progress/time.jsx'),
  VolumeBar = require('./app/components/volume.jsx');

var Callbacks = require('./app/components/callbacks.js');

// Styles
require('./styles/player.scss');
require('./styles/cody.scss');

var CodyPlayer = React.createClass({
  componentDidMount: function () {
    if (this.props.onLoad) this.props.onLoad();
  },
  render: function () {
    return (
      <Player {...this.props} ref='player'>
        <Button role='download'
          icon='download'
          className={['player-btn-download', 'hidden-xs', 'pull-right']}
          onClick={function () {
            if (this.props.onDownloadClick) {
              Callbacks.call(this, 'download', 'before');
              this.props.onDownloadClick.call(this);
              Callbacks.add(this, 'download', 'after');
            }
          }} />
        <PlaylistMenuButton role='playlist-menu' className={['hidden-xs', 'hidden-sm',
          'pull-right']} />
        <VolumeBar role='volume' className={['pull-right']} />
        <MobilePlaylistMenuButton role='playlist-menu' className={['hidden-md', 'hidden-lg']} />
        <Button role='backward'
          icon='step-backward'
          className={['player-btn-backward']} />
        <PlayPauseButton role='toggle' />
        <Button role='forward'
          icon='step-forward'
          className='player-btn-forward' />
        <ProgressBar role='progress-bar' className={['hidden-xs']} />
        <ProgressTime role='progress-time' className={['hidden-xs']} />
        <TrackNumber role='track-number' />
        <TrackMenuButton role='track-menu' className={['hidden-xs', 'hidden-sm']} />
        {this.props.children}
      </Player>
    );
  },

  status: function () {
    return this.refs.player.status();
  }
});

module.exports = CodyPlayer;



// WEBPACK FOOTER //
// ./src/cody.jsx